import React, {Suspense, useEffect} from "react";
import {Redirect, Route, Switch, useLocation} from "react-router-dom";
import {MainPage} from "./pages/MainPage";
import ReactGA from "react-ga4";
import {shallowEqual, useSelector} from "react-redux";
import {ErrorPage1} from "./pages/ErrorPage1";
import {Spinner} from "react-bootstrap";

export default function BasePage() {
    // const {isAuthorized} = useSelector(
    //     ({auth}) => ({
    //         isAuthorized: auth.user != null,
    //     }),
    //     shallowEqual
    // );
    //const location = useLocation();
    // useEffect(() => {
    //     ReactGA.initialize('G-VG3HGQFTYP');
    // }, []);
    // useEffect(() => {
    //     ReactGA.set({page: location.pathname}); // Update the user's current page
    //     ReactGA.send({
    //         hitType: 'pageview',
    //         page: location.pathname,
    //         title: location.pathname,
    //         location: location.pathname + location.search
    //     });
    // }, [location]);
    return (
        <Suspense fallback={<Spinner/>}>
            <Switch>
                <Route exact path="/" component={MainPage}/>
                <Redirect to="error/error-v1"/>
                <Redirect from="/error" exact={true} to="/error/error-v1" />
                <Route path="/error/error-v1" component={ErrorPage1} />
            </Switch>
        </Suspense>
    );
}
